import { Typography, TypographyProps } from "@mui/material";
import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";
import { useBlogCoachCardContext } from "./BlogCoachCardProvider";
import { getLastOrganisation } from "../../../../../lib/specialist";

type BlogCoachCardOrganisationProps = TypographyProps;

export const BlogCoachCardOrganisation = ({
  sx,
  ...props
}: BlogCoachCardOrganisationProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);
  const { state } = useBlogCoachCardContext();
  const lastOrganisation = getLastOrganisation(state.coach);

  if (lastOrganisation) {
    return (
      <Typography
        sx={{
          color: colors.surface.onSurface,
          fontSize: "0.875rem",
          ...sx,
        }}
        {...props}
      >
        {lastOrganisation.name}
      </Typography>
    );
  }
};
